// Quiz question structure — labels live in i18n translations under quiz.questions
export const QUESTIONS = [
  { id: "age", options: ["under_25", "25_34", "35_49", "50_plus"] },
  {
    id: "work_status",
    options: ["remote_employee", "job_offer", "entrepreneur", "student", "retired", "searching"],
  },
  { id: "income", options: ["under_1500", "1500_3000", "3000_5000", "over_5000"] },
  {
    id: "purpose",
    options: ["work", "remote_lifestyle", "study", "retire", "business", "family"],
  },
  { id: "duration", options: ["under_1y", "1_2y", "2_5y", "long_term"] },
  { id: "married_malaysian", options: ["yes", "no"] },
  { id: "savings", options: ["under_10k", "10k_50k", "50k_150k", "over_150k"] },
  { id: "family", options: ["alone", "couple", "with_children"] },
];

export const VISA_ORDER = [
  "mm2h",
  "de_rantau",
  "employment_pass",
  "student_pass",
  "labuan_investor",
  "spouse_ltsvp",
];
